import { render, staticRenderFns } from "./presalePrice.vue?vue&type=template&id=d025d2ae&scoped=true&"
import script from "./presalePrice.vue?vue&type=script&lang=js&"
export * from "./presalePrice.vue?vue&type=script&lang=js&"
import style0 from "./presalePrice.vue?vue&type=style&index=0&id=d025d2ae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d025d2ae",
  null
  
)

export default component.exports